module.exports = __webpack_public_path__ + "img/jordan.a0dc7853.png";